'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useOverlayHashState: ()=>useOverlayHashState
});
const external_react_namespaceObject = require("react");
function useOverlayHashState({ overlayId, defaultOpen = false, hashPrefix = 'overlay' }) {
    const [isOpenState, setIsOpenState] = (0, external_react_namespaceObject.useState)(defaultOpen);
    const isUpdatingFromHashRef = (0, external_react_namespaceObject.useRef)(false);
    const lastHashChangeTimeRef = (0, external_react_namespaceObject.useRef)(0);
    const getOpenFromHash = (0, external_react_namespaceObject.useCallback)(()=>{
        if ('undefined' == typeof window) return defaultOpen;
        const hash = window.location.hash;
        if (hash.startsWith(`#${hashPrefix}=`)) {
            const hashValue = hash.replace(`#${hashPrefix}=`, '');
            return hashValue === overlayId;
        }
        return '' === hash || '#' === hash ? defaultOpen : false;
    }, [
        defaultOpen,
        hashPrefix,
        overlayId
    ]);
    const updateHash = (shouldOpen)=>{
        if ('undefined' == typeof window) return;
        if (shouldOpen) {
            const newHash = `#${hashPrefix}=${overlayId}`;
            window.history.pushState(null, '', newHash);
        } else window.history.pushState(null, '', window.location.pathname + window.location.search);
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        const initialOpen = getOpenFromHash();
        setIsOpenState(initialOpen);
    }, [
        getOpenFromHash
    ]);
    const handleHashChange = (0, external_react_namespaceObject.useCallback)(()=>{
        const openFromHash = getOpenFromHash();
        const now = Date.now();
        if (now - lastHashChangeTimeRef.current < 100) return;
        lastHashChangeTimeRef.current = now;
        isUpdatingFromHashRef.current = true;
        setIsOpenState(openFromHash);
        queueMicrotask(()=>{
            isUpdatingFromHashRef.current = false;
        });
    }, [
        getOpenFromHash
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        window.addEventListener('hashchange', handleHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [
        handleHashChange
    ]);
    const openOverlay = ()=>{
        setIsOpenState(true);
        updateHash(true);
    };
    const closeOverlay = ()=>{
        setIsOpenState(false);
        updateHash(false);
    };
    const handleOpenChange = (open)=>{
        if (isUpdatingFromHashRef.current) return;
        if (isOpenState === open) return;
        setIsOpenState(open);
        updateHash(open);
    };
    return {
        isOpen: isOpenState,
        openOverlay,
        closeOverlay,
        handleOpenChange
    };
}
exports.useOverlayHashState = __webpack_exports__.useOverlayHashState;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useOverlayHashState"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
